import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton } from 'components/atoms/Button/Button';
import HTMLString from 'components/utilities/HTMLString';
import { chevronDown, chevronUp } from 'components/atoms/Icon/icons';
import { translate } from 'utils/translate';

import clip from 'text-clipper';

import * as styles from './Product.scss';

const ExpandableDescription = ({ html, text, truncatedLength, className }) => {
  const [open, setOpen] = useState(false);

  const isExpandable = html
    ? html.length > truncatedLength
    : text.length > truncatedLength;

  const fullContent = html ? <HTMLString html={html} /> : <p>{text}</p>;
  if (!isExpandable) {
    return fullContent;
  }
  const truncatedContent = html ? (
    <HTMLString html={clip(html, truncatedLength - 150, { html: true })} />
  ) : (
    <p>{clip(text, truncatedLength)}</p>
  );
  return (
    <div className={className}>
      {open ? fullContent : truncatedContent}

      <IconButton
        onClick={() => setOpen(!open)}
        iconBefore={open ? chevronUp : chevronDown}
        className={styles.readmoreButton}
        transparent
      >
        {open ? translate('/product/readLess') : translate('/product/readMore')}
      </IconButton>
    </div>
  );
};
ExpandableDescription.displayName = 'ExpandableDescription';
ExpandableDescription.propTypes = {
  html: PropTypes.any,
  text: PropTypes.string,
  truncatedLength: PropTypes.number,
  className: PropTypes.string,
};

ExpandableDescription.defaultProps = {
  truncatedLength: 700,
};
export default ExpandableDescription;
